import { useTimezoneStore } from "@/hooks/store/useTimezoneStore";
import { t } from "i18next";
export const convertDate = (date: Date, timeZone?: string) => {
  const { timezone: companyTimeZone } = useTimezoneStore.getState();
  const [month, ...rest] = date
    .toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      timeZone: companyTimeZone || timeZone,
    })
    .split(" ");
  return `${t(month.toLowerCase() as any)} ${rest.join(" ")}`;
};
